import { ChakraProvider, Flex } from "@chakra-ui/react";
import Header from "../components/molecules/Header";
import Hero from "../components/organisms/Hero";
import Projects from "../components/organisms/Projects";
import PreLoader from "../components/atoms/Preloader";
import About from "../components/organisms/About";
import Journey from "../components/organisms/Journey";
import Contact from "../components/organisms/Contact";
import Footer from "../components/molecules/Footer";
import Skills from "../components/organisms/Skills";
import Testimonials from "../components/organisms/Testimonials";
import SEO from "../components/SEO/SEO";
import "../styles/home.styles.css";
import "../styles/hero.css";
import "../styles/scroll-snap.css";

function HomePage() {
  return (
    <>
      <SEO
        title="Nathan Martins - Frontend Developer & UI/UX Designer | Amsterdam Portfolio"
        description="Experienced frontend developer and UI/UX designer based in Amsterdam. Specializing in React, WebFlow, and creating engaging digital experiences for businesses worldwide."
        keywords="frontend developer, React WebFlow UI UX design Amsterdam portfolio web design digital marketing JavaScript HTML CSS"
        image="https://nathan.marketing/og-image.jpg"
        url="/"
        publishedTime="2023-01-01T00:00:00+00:00"
        modifiedTime="2024-01-01T00:00:00+00:00"
        section="portfolio"
        tags="frontend, development, design, Amsterdam, React, WebFlow"
        category="professional"
      />
      <ChakraProvider>
        <Flex zIndex={999} direction="column" h="100vh" position="relative" className="home-page">
          <Header />
          <PreLoader />
          <Flex direction={"column"} className="scroll-container" flex="1" overflow="auto">
            <Hero />
            <About />
            <Skills />
            <Testimonials />
            <Projects />
            <Journey />
            <Contact />
            <Footer />
          </Flex>
        </Flex>
      </ChakraProvider>
    </>
  );
}

export default HomePage;
